import React from "react"
import Product from "./Product"
import ahoy from "ahoy.js";
import { SearchBar } from "./SearchBar"
import { ProductGallery } from "./ProductGallery"
import { DeliveryDatePickerV2 } from "./DeliveryDatePickerV2"
import { ToastContainer } from 'react-toastify'
import { isTomorrow } from "../../services/Utils"
import { debounceMs } from "../../services/Utils"
import classNames from "classnames"
import { debounce, each, find } from "lodash-es"

export class ProductCatalogV2 extends React.Component {
  constructor(props) {
    super(props)
  }

  render () {
    return (
      <div>
        <CatalogV2 {...this.props} fetcher={this.props.fetcher}/>
        <ToastContainer
          position="bottom-left"
          type="default"
          autoClose={2300}
          className="toastify"
          bodyClassName="toast-notification"
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnHover={false}
        />
      </div>
    )
  }
}

export class CatalogV2 extends React.Component {
  constructor(props) {
    super(props)

    this.addItemToCart = this.addItemToCart.bind(this)
    this.changeLayoutToList = this.changeLayoutToList.bind(this)
    this.changeLayoutToGrid = this.changeLayoutToGrid.bind(this)
    this.openGallery = this.openGallery.bind(this)
    this.changeGalleryIndex = this.changeGalleryIndex.bind(this)
    this.closeGallery = this.closeGallery.bind(this)
    this.toggleExpandedDatePicker = this.toggleExpandedDatePicker.bind(this)
    this.requestProductDetail = this.requestProductDetail.bind(this)
    this.toggleLocalOnly = this.toggleLocalOnly.bind(this)
    this.clearSearch = this.clearSearch.bind(this)

    this.setSort = this.setSort.bind(this)
    this.toggleFilters = this.toggleFilters.bind(this)

    this.setProducer = this.setProducer.bind(this)
    this.setRequestedOn = this.setRequestedOn.bind(this)
    this.onAvailabilityChanged =  this.onAvailabilityChanged.bind(this)

    this.changeLayoutToTable = this.changeLayoutToTable.bind(this)
    this.search = this.search.bind(this)
    this.loadMore = this.loadMore.bind(this)
    this.fetchProducts = debounce(this.fetchProducts, debounceMs(500))

    this.grid = "grid"
    this.list = "list"
    this.table = "table"
    this.deliveryDates = Object.keys(props.delivery_dates).filter(key => props.delivery_dates[key]);

    this.state = {
      showGallery: false,
      layout: this.grid,
      batchSize: 24,
      requestedOn: this.props.requestedOn || '',
      expandDatePicker: !this.props.requestedOn,
      filters: {
        availability: this.props.requestedOn ? 'date-only' : 'any',
        search: '',
        sortBy: 'popularity',
        collection: null,
        subcollection: null,
        collections: [],
        producers: (this.props.selectedProducerId ? [Number(this.props.selectedProducerId)] : []),
        localOnly: false
      },
      productCount: this.props.preloaded_products.length,
      loadingResults: false,
      loadingMore: false,
      loadMoreCount: 0,
      products: [...this.props.preloaded_products],
      nextCursor: this.props.preloaded_next_cursor || null
    }
  }

  clearSearch() {
    let filters = this.state.filters
    ahoy.track("Browse Clear Search", { filters: this.state.filters })

    filters.collection = null
    filters.collections = []
    filters.subcollection = null
    filters.search = ''
    filters.producers = []
    filters.localOnly = false

    this.changeFilters(filters)
  }

  initialProductRequest() {
    let params = this.buildParams()

    this.props
      .fetcher(null, this.state.batchSize, params || {})
      .then(response => {
        if (response.next_cursor) {
          this.requestProductCount(params)
        } else {
          this.setState({ productCount: response.items.length })
        }
        this.loadProducts(response.items, response.next_cursor)
      })
  }

  addItemToCart(buyer_order_item_params, name, src) {
    ahoy.track("Add to Cart", { order_item: buyer_order_item_params, filters: this.state.filters })
    this.props.addItem(buyer_order_item_params, name, src)
  }

  openGallery(index) {
    ahoy.track("Open Gallery", { index: index, filters: this.state.filters })
    this.requestProductDetail(index)
    this.setState({showGallery: true, index: index})
  }

  changeGalleryIndex(index) {
    const modulus = this.state.products.length
    const newIndex = ((index % modulus) + modulus) % modulus // JS positive modulus
    this.requestProductDetail(newIndex)
    this.setState({index: newIndex})
  }

  closeGallery() {
    this.setState({showGallery: false})
  }

  onAvailabilityChanged(event) {
    let filters = this.state.filters
    filters.availability = event.target.value
    this.changeFilters(filters)
  }

  requestProductDetail(index) {
    const products = this.state.products
    const product = products[index]

    let searchParams = { productSlug: product.product_slug }
    if ( this.state.filters.availability == 'date-only' ) {
      searchParams.inStockOn = this.state.requestedOn
    }
    this.props.fetcher(null, 10, searchParams).then(
      (response) => {
        each(response.items, (product) => { product.earliestDeliveryOn =  this.earliestDeliveryOn(product.first_available_on) })
        products[index].otherProducts = response.items
        this.setState({ products: products })
      }
    )
  }

  toggleExpandedDatePicker(){
    this.setState({expandDatePicker: !this.state.expandDatePicker})
  }

  requestProductCount(searchParams) {
    searchParams.count = true
    this.props.fetcher(null, null, searchParams).then(
      (response) => {
        this.setState({ productCount: response.count })
      }
    )
  }

  buildParams() {
    let params = {}
    const filters = this.state.filters
    if ( this.props.buyer_id )
      params.buyerId = this.props.buyer_id
    params.text = filters.search
    params.collections = filters.collections
    params.producers = filters.producers
    params.localOnly = filters.localOnly
    if ( filters.availability == 'date-only' ) {
      params.inStockOn = this.state.requestedOn
    }
    params.sortBy = filters.sortBy

    return params
  }

  // load-more batches grow after the initial page: 2x batchSize, then 4x batchSize
  // (capped there) for every click after that -- e.g. 24, 48, 96, 96, 96...
  nextLoadSize() {
    const sizes = [this.state.batchSize * 2, this.state.batchSize * 4]
    return sizes[Math.min(this.state.loadMoreCount, sizes.length - 1)]
  }

  loadMore() {
    let params = this.buildParams()
    const size = this.nextLoadSize()
    this.setState({ loadingMore: true })

    this.props
      .fetcher(this.state.nextCursor, size, params)
      .then(response => {
        each(response.items, (product) => { product.earliestDeliveryOn = this.earliestDeliveryOn(product.first_available_on) })
        this.setState({
          products: this.state.products.concat(response.items),
          nextCursor: response.next_cursor,
          loadingMore: false,
          loadMoreCount: this.state.loadMoreCount + 1
        })
      })
  }

  componentDidMount() {
    this.loadProducts(this.props.preloaded_products, this.props.preloaded_next_cursor)
    if (this.props.startTerm) {
      this.search(this.props.startTerm)
    }
  }

  fetchProducts() {
    if (this.validSearch()) {
      this.setState({ products: [], nextCursor: null, loadMoreCount: 0, loadingResults: true }, () => {
        this.initialProductRequest()
      })
    } else if (!this.state.filters.search.text) {
      this.setState({ products: [], nextCursor: null, loadMoreCount: 0 }, () => {
        this.loadProducts(this.props.preloaded_products, this.props.preloaded_next_cursor)
      })
    }
  }

  // replace the currently displayed products with a fresh batch
  loadProducts(items, nextCursor) {
    each(items, (product) => { product.earliestDeliveryOn = this.earliestDeliveryOn(product.first_available_on) })
    this.setState({ products: items, nextCursor: nextCursor, loadingResults: false })
  }

  changeSearchTerm(newSearchTerm) {
    let filters = this.state.filters
    const previousSearchTerm = filters.search
    filters.search = newSearchTerm
    this.setState({ filters: filters, loadingResults: true })
    if ( newSearchTerm.trim() == previousSearchTerm.trim() ){ return }
    // wait until the user pauses for more than 500 ms
    setTimeout(() => {
      this.search(newSearchTerm.trim())
    }, 500)
  }

  search(term) {
    let filters = this.state.filters
    if (term == '') {
      const newState = { products: [], nextCursor: null, loadMoreCount: 0, loadingResults: false }
      this.setState(newState, () => {
        this.loadProducts(this.props.preloaded_products, this.props.preloaded_next_cursor)
      })
    } else {
      filters.collections = []
      filters.producers = []
      filters.collection = null
      filters.subcollection = null
      this.setState({ showFilters: false,
                      filters: filters }, this.fetchProducts)
    }
  }

  validSearch() {
    return (
      this.state.filters.localOnly ||
      this.state.filters.search.length > 2 ||
        this.state.filters.collections.length > 0 ||
        this.state.filters.producers.length > 0
    )
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters })
  }

  changeFilters(filters) {
    this.setState(
      { filters: filters, products: [], nextCursor: null, loadMoreCount: 0, loadingResults: true },
      this.fetchProducts
    )
  }

  setCollection(collectionSlug) {
    let filters = this.state.filters
    if (this.state.filters.collection == collectionSlug) {
      filters.collection = null
      filters.subcollection = null
      filters.collections = []
      filters.search = ''
    } else {
      filters.collection = collectionSlug
      filters.subcollection = null
      filters.collections = [collectionSlug]
      filters.search = ''
    }
    this.changeFilters(filters)
  }

  setSubcollection(subcollection, collection) {
    let filters = this.state.filters
    filters.subcollection = subcollection
    if (collection)
      filters.collection = collection
    filters.search = ''
    filters.collections = [subcollection]
    this.changeFilters(filters)
  }

  setSort(event) {
    ahoy.track("Catalog Sort", { sortBy: event.target.value })

    let filters = this.state.filters
    filters.sortBy = event.target.value

    this.changeFilters(filters)
  }

  setProducer(event) {
    let filters = this.state.filters

    filters.producers = event.target.value ? [new Number(event.target.value)] : []

    this.changeFilters(filters)
  }

  setRequestedOn(event) {
    const newRequestedOn = event.currentTarget.value
    this.setState({ requestedOn: newRequestedOn, expandDatePicker: false })
    this.props.updateRequestedOn(newRequestedOn)

    let filters = this.state.filters

    filters.availability = 'date-only'

    this.changeFilters(filters)
  }

  toggleLocalOnly() {
    let filters = this.state.filters
    filters.localOnly = !filters.localOnly

    this.changeFilters(filters)
  }

  renderLoadMoreButton() {
    if (this.state.loadingResults) { return }
    if (!this.state.nextCursor) { return }

    return (
      <div id="catalog-load-more" className="text-center mt-3">
        <button
          className="btn catalog-page-tab-button"
          onClick={this.loadMore}
          disabled={this.state.loadingMore}
        >
          {`Load ${this.nextLoadSize()} More`}
        </button>
        { this.state.loadingMore &&
          <div className="text-center">
            <i className="fa fa-spinner fa-spin fa-pulse fa-lg" aria-hidden="true" />
          </div>
        }
      </div>
    )
  }

  changeLayoutToList() {
    ahoy.track("Layout Change", { language: "JavaScript", layout: 'list' });
    this.setState({ layout: this.list })
  }

  changeLayoutToGrid() {
    ahoy.track("Layout Change", { language: "JavaScript", layout: 'grid' });
    this.setState({ layout: this.grid })
  }

  changeLayoutToTable() {
    ahoy.track("Layout Change", { language: "JavaScript", layout: 'table' });
    this.setState({ layout: this.table })
  }

  renderLayoutButtons() {
    var layout = this.state.layout

    const changeLayoutGridButtonClass = classNames({
      "btn": true,
      "btn-sm": true,
      "mr-2": true,
      "btn-success": layout === this.grid,
      "btn-secondary": layout !== this.grid
    })

    const changeLayoutListButtonClass = classNames({
      "btn": true,
      "btn-sm": true,
      "mr-2": true,
      "btn-success": layout === this.list,
      "btn-secondary": layout !== this.list
    })

    const changeLayoutTableButtonClass = classNames({
      "btn": true,
      "btn-sm": true,
      "mr-2": true,
      "btn-success": layout === this.table,
      "btn-secondary": layout !== this.table
    })

    return (
      <div className="view-options" role="toolbar">
        <div
          onClick={ this.changeLayoutToGrid }
          className={ changeLayoutGridButtonClass }
          role="group"
        >
          <span className="fa fa-th-large" aria-hidden="true" />
        </div>
        <div
          onClick={ this.changeLayoutToList }
          className={ changeLayoutListButtonClass }
          role="group"
        >
          <span className="fa fa-th-list" aria-hidden="true" />
        </div>
        <div id="layout-table"
          onClick={ this.changeLayoutToTable }
          className={ changeLayoutTableButtonClass }
          role="group"
        >
          <i className="fa fa-bars" aria-hidden="true" />
        </div>
      </div>
    )
  }

  earliestDeliveryOn(availableDate){
    const requestedOn = this.state.requestedOn
    return  find(this.deliveryDates, function(deliveryDate) {
      if (requestedOn)
        return deliveryDate >= availableDate && deliveryDate >= requestedOn
      else {
        return deliveryDate >= availableDate;
      }
    })
  }

  renderProductList(pagedProducts) {
    let index = 0
    return pagedProducts.map(
      (product) => {
        return (
          <Product
            product={product}
            anyDateAvailability={ true }
            requestedOn={this.state.requestedOn}
            showAvailability={ this.state.filters.availability == 'any' }
            key={product.product_unit_id}
            openGallery={this.openGallery}
            cartEnabled={this.props.cartEnabled}
            showPricing={this.props.showPricing}
            showImage={this.state.layout === this.grid || this.state.layout === this.list}
            addItem={this.addItemToCart}
            showProducer={this.props.showProducer}
            type={this.state.layout}
            index={index++}
          />
        )
      }
    )
  }

  renderNoResults() {
    if (this.state.loadingResults || this.state.products.length !== 0) { return }
    return (
      <div id="no-results">No Results</div>
    )
  }

  renderSearchNotifier() {
    if ( this.validSearch() && !this.state.loadingResults ) {
      const filters = this.state.filters

      let collectionName;
      if ( this.state.filters.subcollection ) {
        var collection = find(this.props.collections, { slug: this.state.filters.collection })
        collectionName = find(collection.current_children, { slug: this.state.filters.subcollection }).name
      } else if ( this.state.filters.collection ) {
        collectionName = find(this.props.collections, { slug: this.state.filters.collection }).name
      }

      const producer_list = filters.producers.map(
        (id) => { return find(this.props.producers, { id: id }).name }
      )

      let terms = producer_list
      if (this.state.filters.search) {
        terms.push(this.state.filters.search)
      }
      if (collectionName) {
        terms.push(collectionName)
      }
      if (filters.localOnly) {
        terms.push("Local Products Only")
      }

      const productCount = this.state.productCount
      const loadedCount = this.state.products.length

      const message = terms.join('", "')

      let countMsg
      if (productCount == 0) {
        countMsg = 'There are no'
      } else if (loadedCount >= productCount) {
        countMsg = `Showing all ${productCount}`
      } else {
        countMsg = `Showing ${loadedCount} of ${productCount}`
      }

      let dateFilterMsg = ''
      if (filters.availability == 'date-only') {
        let requested = new Date(this.state.requestedOn + 'T12:00:00Z')
        let day = requested.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        dateFilterMsg = `deliverable on ${ day } `
      }

      return (
        <div className="search-notifier">
          {`${countMsg} products ${ dateFilterMsg }matching "${message}"`}
          <button className='btn btn-xs border ml-1' onClick={ this.clearSearch }>
            <span className='fa fa-times mr-1'></span>
            Clear
          </button>
        </div>
      )
    } else if (!this.validSearch() && this.state.filters.search != "") {
      return (<div className="search-notifier text-danger">Please enter at least 3 characters</div>)
    } else {
      return (<div className="search-notifier"></div>)
    }
  }

  renderWaitSpinner() {
    if (this.state.loadingResults && this.validSearch() ) {
      return (
        <div className="text-center">
          <i
            className="fa fa-spinner fa-spin fa-pulse fa-lg"
            aria-hidden="true"
          />
        </div>
      )
    }
  }

  renderOrderDeadlineText() {
    return (
      <div className="text-center text-danger lead font-weight-bold">{this.props.seller.ordering_message}</div>
    )
  }

  renderSellerLogo() {
    const seller = this.props.seller
    let logoContent = (<h3>{ seller.name }</h3>)
    if (seller.logo_url) {
      logoContent = (<img className='img-fluid' src={ seller.logo_url } />)
    }
    return (
      <div>
        { logoContent }
      </div>
    )
  }

  renderCollections() {
    return (
      <div>
        <div>
          { this.renderCollectionToggles() }
        </div>
      </div>
    )
  }

  renderCollectionToggles() {
    if (this.props.collections.length < 2) { return }
    return this.props.collections.map( (collection) => {
      var collectionClasses = classNames({
        'collection-clicker': true,
        "active": this.state.filters.collection == collection.slug
      })

      var children = []
      if ( collection.slug == this.state.filters.collection ) {
        children = collection.current_children.map( (child_collection) => {
          var subcollectionClasses = classNames({
            'ml-3': true,
            'subcollection-clicker': true,
            "active": this.state.filters.subcollection == child_collection.slug
          })
          return (
            <div key={ child_collection.slug } className={ subcollectionClasses } onClick={() => this.setSubcollection(child_collection.slug) }>
              { child_collection.name }
            </div>
          )
        })
      }

      return (
        <div key={collection.slug}>
          <div className={ collectionClasses } onClick={() => this.setCollection(collection.slug) }>
            <span>{ collection.name }</span>
            <span className='ml-1 dropdown-toggle'></span>
          </div>
          { children }
        </div>
      )
    })
  }

  renderAvailableOnlyToggle() {
    return (
      <div className='mt-1'>
        <div className='font-weight-bold small'>PRODUCT AVAILABILITY</div>
        <div className="form-check">
          <input id='availability-date-only' className="form-check-input" name='availability-radio' type="radio" onChange={this.onAvailabilityChanged} value="date-only" checked={this.state.filters.availability == 'date-only'}  />
          <label htmlFor='availability-date-only' className="form-check-label">Available on delivery date</label>
        </div>
        <div className="form-check">
          <input id='availability-any' className="form-check-input" name='availability-radio' type="radio" onChange={this.onAvailabilityChanged} value="any" checked={this.state.filters.availability == 'any'}  />
          <label htmlFor='availability-any' className="form-check-label">View full catalog</label>
        </div>
      </div>
    )
  }

  renderProducers() {
    const producerOptions = this.props.producers.map((producer) => {
      return <option key={producer.id} value={producer.id}>{ `${producer.name} ${producer.city_state}` }</option>
    })

    return (
      <div className='mt-3'>
        <label className='mb-1 font-weight-bold' htmlFor='producer-select'>PRODUCERS</label>
        <select id='producer-select' className='form-control form-control-sm' onChange={this.setProducer} value={this.state.filters.producers[0] || ''}>
          <option value=''>-- All Producers --</option>
          { producerOptions }
        </select>
      </div>
    )
  }

  formatDate(date_string) {
    if (!date_string) { return <span className='small text-danger'>NOT SELECTED</span> }
    if (isTomorrow(date_string)) { return 'Tomorrow' }

    let date = new Date(date_string + 'T12:00:00Z')
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })
  }

  renderEditDateIcon() {
    if (this.state.expandDatePicker) { return }

    return (<span className='fa fa-edit fa-sm text-muted ml-2'></span>)
  }

  renderRequestFor() {
    const dates_on = Object.values(this.props.delivery_dates || {})
    const count_on = dates_on.filter((element) => element === true).length
    if ( count_on == 0 ) { return }

    return (
      <div>
        <div className='font-weight-bold small'>
          DELIVERY DATE
        </div>

        <div className='d-flex d-md-block flex-wrap'>
          <div className='align-self-center'>
            <button className='btn btn-lg px-0 pt-0 w-100 text-left' onClick={ this.toggleExpandedDatePicker }>
              { this.formatDate(this.state.requestedOn) }
              { this.renderEditDateIcon() }
            </button>
          </div>
        </div>
        <DeliveryDatePickerV2 available_days={this.props.delivery_dates}
                              requested_on={this.state.requestedOn}
                              expanded={this.state.expandDatePicker}
                              toggleExpanded={ this.toggleExpandedDatePicker }
                              onChange={this.setRequestedOn} />
      </div>
    )
  }

  renderDownload() {
    if ( !this.props.showPricing ) { return }

    return (
      <div className='mt-4 d-none d-md-block'>
        <a href={`/admin/seller/${ this.props.seller.slug }/catalog_download.csv`}>
          <span className='fa fa-download mr-1'></span>
          Download Catalog
        </a>
      </div>
    )
  }

  renderLocalOnlyToggle() {
    return (
      <div className='form-check mt-3'>
        <input checked={ this.state.filters.localOnly } className='form-check-input' type='checkbox' id='search-local-only' onChange={ this.toggleLocalOnly }/>
        <label className='form-check-label font-weight-bold small' htmlFor='search-local-only'>LOCAL PRODUCTS ONLY</label>
      </div>
    )
  }

  renderSort() {
    if ( !this.validSearch()) { return }
    return (
      <select className='form-control form-control-sm' onChange={this.setSort} selected={this.state.filters.sortBy}>
        <option value='popularity'>Popularity</option>
        <option value='product_az'>Product Name, A-Z</option>
        <option value='unit_az'>Unit Size, A-Z</option>
        <option value='producer_az'>Producer, A-Z</option>
        <option value='price_hl'>Price, High-Low</option>
        <option value='price_lh'>Price, Low-High</option>
      </select>
    )
  }

  renderFilterSidebar() {
    var sidebarToggleClass = classNames({
      'd-md-block py-md-3 pb-3': true,
      'd-none': !this.state.showFilters
    })

    return (
      <div id='sidebar' className='col-md-4 col-lg-3'>
        <div className="mb-3">
          { this.props.collections.length ? this.renderRequestFor() : null  }
          { this.props.collections.length ? this.renderAvailableOnlyToggle() : null}
          { this.props.collections.length ? this.renderLocalOnlyToggle() : null }
        </div>
        <div>
          { this.props.collections.length ? null : this.renderRequestFor() }
          { this.props.collections.length ? null : this.renderAvailableOnlyToggle() }
          { this.props.collections.length ? null : this.renderLocalOnlyToggle() }
        </div>
        <div className={sidebarToggleClass}>
          <div id="category-toggles">
            { this.renderCollections() }
          </div>
          <div id='toggles'>
            { this.renderProducers() }
            { this.renderDownload() }
          </div>
        </div>
      </div>
    )
  }

  renderHeader() {
    return (
      <div id="catalog-header" className='row justify-content-center justify-content-md-start'>
        <div id="logo" className='col-md-3 col-4 d-flex'>
          { this.renderSellerLogo() }
        </div>
        <div id="search" className='col-md-9 col-12'>
          <div>
            { this.renderOrderDeadlineText() }
          </div>
          <div id="search-row" className='d-flex'>
            <div id="search-box" className='align-self-center flex-fill'>
              <SearchBar collections={this.props.collections}
                          setSubcollection={this.setSubcollection.bind(this)}
                          setCollection={this.setCollection.bind(this)}
                          value={this.state.filters.search}
                          onChange={this.changeSearchTerm.bind(this)} />
            </div>
            <div id="cart-icon"> {this.props.cart} </div>
          </div>
          { this.renderSearchNotifier() }
        </div>
      </div>
    )
  }

  renderProductsContainer(products) {
    if (this.state.layout === this.table) {
      return (
        <table id="products-table" className="table table-hover table-sm product-table">
          <thead>
            <tr>
              <th>Producer</th>
              <th>Product / Unit</th>
              <th className="product-table-price">Price</th>
              <th className="product-table-actions"></th>
            </tr>
          </thead>
          <tbody>
            { this.renderProductList(products) }
          </tbody>
        </table>
      )
    }

    return (
      <div id="products">
        { this.renderProductList(products) }
      </div>
    )
  }

  renderResults() {
    const products = this.state.products

    return (
      <div id="products-body" className='col-md-8 col-lg-9 col-12'>
        <div id='products-header' >
          <div>
            { this.renderNoResults() }
          </div>
          <div className='d-md-none mb-2'>
            <button className='btn border-dark btn-block' onClick={ this.toggleFilters.bind(this)} >
              Collections and Filters
              <span className='ml-2 dropdown-toggle'></span>
            </button>
          </div>
          <div className='d-flex justify-content-between align-content-center'>
            <div className='d-md-block' id="layout-options">
              { this.renderLayoutButtons() }
            </div>
            <div>
              { this.renderWaitSpinner() }
            </div>
            <div>
              { this.renderSort() }
            </div>
          </div>
        </div>
        { this.renderProductsContainer(products) }
        { this.state.productCount > 12 && this.renderSearchNotifier() }
        { this.renderLoadMoreButton() }
      </div>
    )
  }

  render() {
    const layout = this.state.layout
    const products = this.state.products

    return (
      <div id="catalog">
        <ProductGallery
          index={this.state.index}
          visible={this.state.showGallery}
          anyDateAvailability={ true }
          requestedOn={ this.state.requestedOn }
          showAvailability={ this.state.filters.availability == 'any' }
          cartEnabled={this.props.cartEnabled}
          requestProductDetail={this.requestProductDetail}
          closeGallery={this.closeGallery}
          changeGalleryIndex={this.changeGalleryIndex}
          addItem={this.addItemToCart}
          product_unit={products[this.state.index]}
          showPricing={this.props.showPricing}
        />
        { this.renderHeader() }
        <div id="catalog-body" className='row'>
          { this.renderFilterSidebar() }
          { this.renderResults() }
        </div>
      </div>
    )
  }
}
